<template>
  <div>
    <div class="form-group" v-show="this.data.visibility !== 'hidden'">
      <label v-show="this.showLabel"> {{label}} </label>
      <input class="form-control" :required="required" v-model="value" :placeholder="placeholder" v-if="!this.area"
             :name="this.data.tag"/>
      <textarea class="form-control" :required="required" v-model="value" :placeholder="placeholder"
                v-if="this.area" :name="this.data.tag"></textarea>
      <small class="form-text text-muted" v-show="data.help_text != ''">{{data.help_text}}</small>
    </div>
  </div>
</template>

<script>
	export default {
		name: 'InputFieldMailingBoss',
		props: ['label', 'value', 'data', 'area', 'showPlaceholder', 'showLabel'],
		data() {
			return {}
		},
		computed: {
			placeholder() {
				return this.showPlaceholder ? this.label : ''
			},
			required() {
				return this.data.required === 'yes';
			},
		}
	}
</script>
<style scoped>
  textarea {
    resize: none;
  }
</style>
